var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13922",
    "data-name": "Group 13922",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.84,
    height: 21.84,
    viewBox: "0 0 21.84 21.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5129",
    "data-name": "Rectangle 5129",
    width: 21.84,
    height: 21.84,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13246",
    "data-name": "Group 13246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45503",
    "data-name": "Path 45503",
    d: "M12.261,0c1.352.371,1.036,1.832,1.3,2.9l1.188.491c.953-.582,1.9-1.983,3.109-1.008a14.489,14.489,0,0,1,1.8,1.905c.5,1.164-.662,1.9-1.206,2.775l.487,1.213c1.071.269,2.527-.055,2.9,1.3v2.64c-.381,1.355-1.828,1.035-2.9,1.3l-.491,1.188c.577.941,1.962,1.892,1.029,3.088a16.3,16.3,0,0,1-1.663,1.658c-1.16.892-2.142-.46-3.039-1.044l-1.213.487c-.247,1.028.018,2.775-1.45,2.9a17.617,17.617,0,0,1-2.345,0c-1.441-.125-1.231-1.864-1.432-2.889l-1.182-.5c-.953.506-1.789,1.891-3.013,1.1a16.78,16.78,0,0,1-1.758-1.734c-.878-1.142.413-2.114,1.016-2.988l.027-.1-.5-1.182c-1-.2-2.746.007-2.887-1.391A16.5,16.5,0,0,1,.059,9.535,1.437,1.437,0,0,1,1.138,8.527c.24-.051,1.749-.177,1.8-.25l.487-1.213c-.583-.9-1.939-1.875-1.045-3.039A16.282,16.282,0,0,1,4.3,2.193c1.189-.542,1.928.676,2.831,1.2L8.318,2.9C8.587,1.829,8.263.373,9.621,0Zm-1.8,6.4a4.525,4.525,0,1,0,4.374,6.8,4.541,4.541,0,0,0-4.374-6.8",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.6ade6b052242044ebf0e7dc4c11bc92b.svg";
export { ForwardRef as ReactComponent };